"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blobToFormPart = blobToFormPart;
exports.castArray = void 0;
exports.decodeBytes = decodeBytes;
exports.ensureEncoding = ensureEncoding;
exports.getFormData = getFormData;
exports.isWebFormData = exports.isStream = exports.isObject = exports.isNodeJS = exports.isFormData = exports.isBytes = exports.isBrowser = exports.isBlob = void 0;
exports.normalizeFormPart = normalizeFormPart;
exports.normalizeTrailingSlashInPath = normalizeTrailingSlashInPath;
exports.setFormData = setFormData;
exports.toBytes = toBytes;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Casts `value` as an array if it's not one.
 * Equivalent to lodash/castArray
 */
var castArray = exports.castArray = function castArray(value) {
  return Array.isArray(value) ? value : [value];
};
var isObject = exports.isObject = function isObject(value) {
  return null != value && _typeof(value) === 'object';
};
var isFormData = exports.isFormData = function isFormData(value) {
  if (!value) {
    return false;
  }
  var FormData = getFormData();
  if (value instanceof FormData) {
    return true;
  }
  return value && value.constructor && value.constructor.toString().trim().indexOf('function FormData') === 0;
};
var isStream = exports.isStream = function isStream(value) {
  var stream = require('stream');
  return value instanceof stream.Stream;
};
var isNodeJS = exports.isNodeJS = function isNodeJS() {
  return typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
};
var isBrowser = exports.isBrowser = function isBrowser() {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
var CustomFormData = null;
function getFormData() {
  if (CustomFormData) {
    return CustomFormData;
  }
  return isNodeJS() || typeof FormData === 'undefined' ? require('form-data') : FormData;
}
function setFormData(value) {
  CustomFormData = value;
}

//                         @      :      /      #      ?      =      $      &      +
var SAFE_CHAR_CODES = ['%40', '%3A', '%2F', '%23', '%3F', '%3D', '%24', '%26', '%2B'];
function safeEscape(str, charCodes) {
  var _char = charCodes[0];
  if (_char) {
    var tokens = str.split(_char).map(function (p) {
      return safeEscape(p, charCodes.slice(1));
    });
    return tokens.join(_char);
  }
  return encodeURI(str);
}
function ensureComponentEncoding(uriComponent) {
  if (uriComponent === decodeURI(uriComponent)) {
    return safeEscape(uriComponent, [].concat(SAFE_CHAR_CODES));
  }
  return uriComponent;
}
function encodePath(path) {
  return path.split('/').map(ensureComponentEncoding).join('/');
}
function ensureEncoding(path) {
  try {
    var url = new URL(path);
    return url.origin + encodePath(normalizeTrailingSlashInPath(path, url)) + url.search;
  } catch (_unused) {
    return encodePath(path);
  }
}
function normalizeTrailingSlashInPath(originPath, _ref) {
  var pathname = _ref.pathname;
  if (originPath.includes('?')) {
    originPath = originPath.split('?')[0];
  }
  var keepTrailingSlash = originPath.endsWith('/');
  return !keepTrailingSlash && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
}
var isBytes = exports.isBytes = function isBytes(value) {
  return typeof Uint8Array !== 'undefined' && value instanceof Uint8Array;
};

/**
 * Normalizes a raw response body to bytes.
 *
 * A Buffer is a Uint8Array, so the check a caller needs is `instanceof Uint8Array` in both
 * environments, and the value we already have is handed back as is - no copy, these are file
 * payloads and a single one is routinely tens of MB.
 *
 * Everything else can only come from an empty response or from a replaced `Request.send`,
 * both of them cheap to convert. Anything that is not convertible is a broken contract and
 * throws rather than silently uploading wrong bytes.
 *
 * @param {*} value
 * @returns {Buffer|Uint8Array}
 */
function toBytes(value) {
  if (isBytes(value)) {
    return value;
  }
  var hasBuffer = typeof Buffer !== 'undefined' && typeof Buffer.from === 'function';
  if (value === undefined || value === null || value === '') {
    return hasBuffer ? Buffer.alloc(0) : new Uint8Array(0);
  }
  if (typeof value === 'string') {
    return hasBuffer ? Buffer.from(value, 'utf8') : new TextEncoder().encode(value);
  }
  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return hasBuffer ? Buffer.from(value) : new Uint8Array(value);
  }
  throw new Error('The response body can not be represented as bytes, ' + "received ".concat(value === null ? 'null' : _typeof(value), ". ") + 'This happens when "Request.send" is replaced with an implementation ' + 'that does not return the raw body for a request made with "toBuffer()".');
}

/**
 * Decodes bytes to utf8 text, anything which is not bytes is passed through.
 *
 * Used for the error body of a raw request: a browser gets it as a Uint8Array, because
 * `responseType` is set for the whole response, and `String()` on a Uint8Array joins the byte
 * values with commas instead of decoding them
 *
 * @param {*} value
 * @returns {*}
 */
function decodeBytes(value) {
  if (!isBytes(value)) {
    return value;
  }
  if (typeof Buffer !== 'undefined' && Buffer.isBuffer(value)) {
    return value.toString('utf8');
  }
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder('utf8').decode(value);
  }
  return value;
}

/**
 * A Blob or a File, duck typed so that an instance coming from another realm is recognized too
 */
var isBlob = exports.isBlob = function isBlob(value) {
  return !!value && _typeof(value) === 'object' && typeof value.stream === 'function' && typeof value.arrayBuffer === 'function' && typeof value.size === 'number';
};

/**
 * The FormData of the WHATWG spec - the Node 18+ global one, or the browser one.
 *
 * The `form-data` npm package, which is what `Request.FormData` is in Node js, is a different
 * class with a different API and it is recognized by `isFormData`
 */
var isWebFormData = exports.isWebFormData = function isWebFormData(value) {
  return !!value && typeof value.append === 'function' && typeof value.getAll === 'function' && typeof value.forEach === 'function' && typeof value.getHeaders !== 'function';
};

/**
 * Turns a Blob or a File into something the `form-data` package can stream.
 *
 * The package accepts a Buffer or a stream and treats any other object as stream like, which
 * makes it throw "source.on is not a function" from inside `combined-stream` at append time.
 * A web stream is not that either, `Readable.fromWeb` bridges the two.
 *
 * `knownLength` is what keeps `form.getLength()` synchronous and the content-length header
 * correct, and the filename follows what a browser sends for a nameless Blob
 *
 * @param {Blob|File} blob
 * @returns {{ value: Object, options: Object }}
 */
function blobToFormPart(blob) {
  var _require = require('stream'),
    Readable = _require.Readable;
  if (typeof Readable.fromWeb !== 'function') {
    throw new Error('A Blob can only be added to a form on Node 18 or newer, ' + 'pass a Buffer or a stream instead.');
  }
  var options = {
    knownLength: blob.size,
    filename: blob.name || 'blob'
  };
  if (blob.type) {
    options.contentType = blob.type;
  }
  return {
    value: Readable.fromWeb(blob.stream()),
    options: options
  };
}

/**
 * Prepares a value for `FormData#append` of the `form-data` package.
 *
 * Everything the package can not stream is either converted here or reported with an error which
 * names the field, instead of the "source.on is not a function"/"Illegal invocation" thrown from
 * deep inside `combined-stream` with nothing pointing at the value which caused it
 *
 * @param {String} key
 * @param {*} value
 * @returns {{ value: *, options: Object|undefined }}
 */
function normalizeFormPart(key, value) {
  if (isBlob(value)) {
    return blobToFormPart(value);
  }
  if (isBytes(value) && typeof Buffer !== 'undefined' && !Buffer.isBuffer(value)) {
    // a Uint8Array is not a Buffer and the package treats it as a stream, the view is
    // wrapped without copying the bytes
    return {
      value: Buffer.from(value.buffer, value.byteOffset, value.byteLength)
    };
  }
  if (isObject(value) && !isStream(value) && !(typeof Buffer !== 'undefined' && Buffer.isBuffer(value))) {
    throw new Error("The form field \"".concat(key, "\" can not be sent, ") + "expected a Buffer, a stream, a Blob or a primitive value, received ".concat(describeValue(value), "."));
  }
  return {
    value: value
  };
}
function describeValue(value) {
  if (Array.isArray(value)) {
    return 'an Array';
  }
  var name = value.constructor && value.constructor.name;
  return name ? "an instance of ".concat(name) : 'an object';
}